  import React, { useEffect, useState } from "react";
  import axios from "axios";
  import { useParams } from "react-router-dom";

  const API = process.env.REACT_APP_API_URL
  
  export default function PagamentoConfirm() {
    const { id } = useParams();
    const [cobranca, setCobranca] = useState(null);
    const [aceitou, setAceitou] = useState(false);
    const [ip, setIp] = useState("desconhecido");
    const [coords, setCoords] = useState(null);
    const [device] = useState(window.navigator.userAgent);
    const [enviando, setEnviando] = useState(false);
    const [erro, setErro] = useState("");

    useEffect(() => {
      axios.get(`${API}/cobrancas/${id}`)
        .then(res => setCobranca(res.data))
        .catch(() => setErro("Cobrança não encontrada ou erro no servidor."));
    }, [id]);

    useEffect(() => {
      axios.get("https://api64.ipify.org?format=json")
        .then(res => setIp(res.data.ip))
        .catch(() => setIp("desconhecido"));
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          pos => setCoords({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
          () => setCoords({ error: "negada" })
        );
      }
    }, []);

    const handleConfirm = async () => {
      if (enviando) return;
      setEnviando(true);
      try {
        await axios.post(`${API}/cobrancas/${id}/registro`, {
          aceitou: true,
          ip,
          coords,
          device,
          horario: new Date().toISOString()
        });
        sessionStorage.setItem("cobranca_id", cobranca.id);
    
        if (cobranca.metodo === "pix") {
          window.location.href = `/pix/${cobranca.id}`;
        } else if (cobranca.link) {
          window.location.href = cobranca.link;
        } else {
          alert("Link de pagamento não encontrado!");
        }
      } catch (err) {
        alert("Erro ao registrar aceite: " + (err.response?.data?.error || err.message));
      }
      setEnviando(false);
    };    

    if (erro) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="bg-white p-8 rounded-2xl shadow-xl text-red-600 font-bold text-center">
            {erro}
          </div>
        </div>
      );
    }

    if (!cobranca) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          Carregando...
        </div>
      );
    }

    if (cobranca.status !== "pending" && cobranca.status !== "in_process") {
      let msg = "Esta cobrança já foi finalizada ou está indisponível.";
      if (cobranca.status === "approved") msg = "Cobrança já PAGA! Obrigado.";
      if (cobranca.status === "rejected") msg = "Cobrança REJEITADA pelo Mercado Pago.";
      if (cobranca.status === "cancelled") msg = "Cobrança CANCELADA.";
      if (cobranca.status === "refunded") msg = "Cobrança ESTORNADA.";
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 text-center px-4">
          <div className="bg-white p-6 rounded-xl shadow-md text-red-600 font-semibold">
            {msg}
          </div>
        </div>
      );
    }

    // Ajuste para exibir corretamente a modalidade (pix/cartão)
    const modalidade = cobranca.metodo === "pix"
      ? "Pix"
      : cobranca.metodo === "cartao" || cobranca.metodo === "cartão"
        ? "Cartão"
        : "Cartão/Pix";

    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <div className="max-w-lg bg-white p-8 rounded-2xl shadow-xl">
          <h1 className="text-xl font-bold mb-4">Confirmação de Pagamento</h1>
          <p className="mb-2">Nome: <b>{cobranca.nome || "--"}</b></p>
          <p className="mb-2">CPF: <b>{cobranca.cpf || "--"}</b></p>
          <p className="mb-2">Telefone: <b>{cobranca.telefone || "--"}</b></p>
          <p className="mb-2">E-mail: <b>{cobranca.email || "--"}</b></p>
          <p className="mb-2">
            Valor: <b>
              R$ {cobranca.valor !== undefined && cobranca.valor !== null
                ? Number(cobranca.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                : "--"}
            </b>
          </p>
          <p className="mb-2">
            Modalidade: <b>
              {modalidade}
            </b>
          </p>
          <div className="mt-6 mb-6 bg-yellow-100 border border-yellow-200 rounded-lg p-4 text-sm max-h-60 overflow-y-auto">
            <b>TERMO DE RESPONSABILIDADE E CONSENTIMENTO PARA PAGAMENTO E EMISSÃO DE NOTA FISCAL</b>
            <br /><br />
            Declaro, sob as penas da lei, para os devidos fins de direito:
            <ul className="list-disc ml-5 my-2 text-xs">
              <li>Que todos os dados pessoais aqui informados para a realização do pagamento, emissão de nota fiscal eletrônica e contato (nome, CPF, telefone, e-mail) são verdadeiros, completos e de minha titularidade exclusiva.</li>
              <li>Que autorizo, de forma expressa e irrevogável, a emissão da nota fiscal eletrônica em meu nome, reconhecendo ser o responsável exclusivo pelas informações prestadas neste ato.</li>
              <li>Que tenho plena ciência de que a utilização de dados de terceiros, sem a devida autorização, caracteriza conduta ilícita e configura crime de falsidade ideológica, nos termos do art. 299 do Código Penal Brasileiro.</li>
              <li>Que concordo e consinto expressamente que meu endereço IP, localização aproximada e dados do dispositivo utilizados para esta transação sejam coletados e armazenados para fins de segurança, prevenção à fraude, auditoria e atendimento a eventuais demandas judiciais ou administrativas.</li>
              <li>Que assumo total responsabilidade civil e criminal pelo uso das informações inseridas nesta plataforma, isentando a empresa vendedora de qualquer responsabilidade decorrente da inexatidão ou falsidade dos dados informados.</li>
            </ul>
            <b>Ao clicar em "Aceito e quero pagar", estou ciente e de acordo com todos os termos acima, assumindo integral responsabilidade por esta transação.</b>
          </div>
          <label className="flex items-center space-x-2 mb-4">
            <input type="checkbox" checked={aceitou} onChange={e => setAceitou(e.target.checked)} />
            <span>Li e aceito integralmente o termo acima.</span>
          </label>
          <button
            className="w-full bg-indigo-700 hover:bg-indigo-800 text-white font-bold rounded-xl py-3 text-lg shadow-md transition disabled:opacity-50"
            disabled={!aceitou || enviando}
            onClick={handleConfirm}
          >
            {enviando ? "Redirecionando..." : "Aceito e quero pagar"}
          </button>
        </div>
      </div>
    );
  }
